import { OmitType } from '../../codegen';
import { OMIT_RETURN_TIME_FIELDS } from '../../constants';

import { GameBase } from './game.entity';
export class GameReturnDto extends OmitType(
  GameBase,
  OMIT_RETURN_TIME_FIELDS,
) {}
